interface ProjectMetadata {
  id?: number;
  brandId?: number | null; brand_id?: number | null;
  adAccountId?: number | null; ad_account_id?: number | null;
  parentId?: number | null; parent_id?: number | null;
}

/** Sidebar rows are navigation hints, not edits. Missing/stale null hints must
 * not erase metadata already attached to the task by its running stream. */
export function resolveProjectNavigation(hint: ProjectMetadata = {}, existing?: ProjectMetadata, parent?: ProjectMetadata) {
  const parentId = hint.parentId !== undefined ? hint.parentId : hint.parent_id !== undefined ? hint.parent_id : existing?.parentId ?? existing?.parent_id ?? null;
  const ownParent = parentId != null && parent?.id === parentId ? parent : undefined;
  return {
    brandId: hint.brandId ?? hint.brand_id ?? existing?.brandId ?? existing?.brand_id ?? ownParent?.brandId ?? ownParent?.brand_id ?? null,
    adAccountId: hint.adAccountId ?? hint.ad_account_id ?? existing?.adAccountId ?? existing?.ad_account_id ?? ownParent?.adAccountId ?? ownParent?.ad_account_id ?? null,
    parentId,
  };
}

/** No-hint callers (clone destinations and direct links) must resolve the
 * actual task before proceeding; the previous task's global brand is unsafe. */
export async function loadProjectNavigation(
  projectId: number,
  hint: ProjectMetadata | undefined,
  existing: ProjectMetadata | undefined,
  read: (id: number) => Promise<ProjectMetadata>,
) {
  const known = resolveProjectNavigation(hint, existing);
  if (known.brandId != null) return known;
  const task = await read(projectId);
  if (task.id !== projectId) throw new Error('Received metadata for a different task.');
  const own = resolveProjectNavigation(task);
  const parent = own.brandId == null && own.parentId != null ? await read(own.parentId) : undefined;
  return resolveProjectNavigation(task, undefined, parent);
}
